import { type ReactNode, type Ref } from 'react'
import { AccessDeniedView } from '@/components/AccessDeniedView'
import styles from './UserManagement.module.css'

export interface UserManagementProps {
  canAccessUserManagement: boolean
  corporateMode: boolean
  scrollRef: Ref<HTMLDivElement>
  children: ReactNode
}

export function UserManagement({
  canAccessUserManagement,
  corporateMode,
  scrollRef,
  children,
}: UserManagementProps) {
  return canAccessUserManagement ? (
    <div ref={scrollRef} className={styles.root}>
      {children}
    </div>
  ) : (
    <AccessDeniedView
      corporateMode={corporateMode}
      testId="user-management-access-denied"
    />
  )
}
